import { AskQuestionForm } from '@/components/ask-question-form';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { QuestionInfoType } from '@/types/api/question';
import React from 'react';

interface EditQuestionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  questionInfo: QuestionInfoType;
}

export const EditQuestionDialog = ({
  open,
  onOpenChange,
  questionInfo,
}: EditQuestionDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="min-w-[800px]">
        <DialogTitle className="text-sm font-bold">Edit question</DialogTitle>
        <AskQuestionForm
          isModal
          isEdit
          defaultQuestionInfo={questionInfo}
          onUpdateSuccessCallback={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
};
